/* eslint-disable */
import React, { useEffect, useState } from 'react';
import HomeScreenPicture from '../../assets/images/home-image1.png';
import './Home.scss';
import AGGrid from './AGGrid';
import GridHeader from '../../components/GridHeader/GridHeader';

interface HomeProps {
  filterResult?: {
    year: number | null;
    customer: number | null;
    category: number | null;
    brand: number | null;
    isSummaryView: boolean;
    customerName: string | null;
    categoryName: string | null;
    brandName: string | null;
  } | null;
}

const Home: React.FC<HomeProps> = ({ filterResult }) => {
  const [activeFilter, setActiveFilter] = useState(filterResult);
  
  useEffect(() => {
    setActiveFilter(filterResult);
  }, [filterResult]);

  useEffect(() => {
    const handleFilterChange = () => {
      setActiveFilter(null);
    };

    window.addEventListener('filters:changed', handleFilterChange);

    return () => {
      window.removeEventListener('filters:changed', handleFilterChange);
    };
  }, []);

  if (activeFilter) {
    return <AGGrid filterResult={activeFilter} />;
  }

  return (
    <div className="home-container">
      <GridHeader
        isQuarterly={false}
        disabled={true}
        hasChanges={false}
      />

      <div className="home-body">
        <img src={HomeScreenPicture} alt="Home Illustration" className="home-illustration" />

      </div>
    </div>
  );
};

export default Home;
